import React from 'react';
import { ScrollArea } from '../components/ui/scroll-area';
import { Button } from '../components/ui/button';
import { LifeBuoy, PlayCircle } from 'lucide-react';
import { HelpContent } from '../components/HelpContent';
import { TourVideoButton } from '../components/TourVideoDialog';

export default function HelpPage() {
  return (
    <ScrollArea className="h-full">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-2">
          <LifeBuoy className="h-5 w-5" style={{ color: 'hsl(var(--primary))' }} />
          <h1 className="font-display text-2xl font-700">How to use Larkwell</h1>
        </div>
        <p className="text-[hsl(var(--muted-foreground))] mt-1 mb-4">A short, friendly guide. Take what helps and ignore the rest — there is no wrong way to use Larkwell.</p>
        <div className="flex flex-wrap items-center gap-2 mb-6">
          <TourVideoButton label="Watch the 2-min tour" testId="help-watch-tour-button" />
          <Button variant="outline" className="rounded-xl gap-2" onClick={() => window.dispatchEvent(new Event('larkwell:replay-tour'))} data-testid="replay-tour-help-button">
            <PlayCircle className="h-4 w-4" /> Replay the guided tour
          </Button>
        </div>
        <HelpContent includeTesters={true} />
      </div>
    </ScrollArea>
  );
}
